
import BaseModel from "../base_model.js";
import I18n from "../../base/i18n.js.jsx";

import ListMenusUseCase from "../../use_cases/admin/menus/menus/list_menus_use_case.js";
import ListDownloadablesUseCase from "../../use_cases/admin/downloadables/list_downloadables_use_case.js"

import { TopBarHeight } from "../../admin/constants.js";

class RawPageModel extends BaseModel {

  rawListFields() {
    return [
      {
        name: "description",
        displayName: this.fieldDisplayName("description"),
        type: "text",
        sortKey: "description"
      },
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        sortKey: "name"
      },
      {
        name: "menu",
        displayName: this.fieldDisplayName("menu"),
        renderFunction: (page, column, onChangeColumn, items) => {
          if (page.menu == "main")
            return "Top Menu"

          var main_menu = items.find(item => item.slug==page.menu)
          if (main_menu != undefined)
            return main_menu.name

          return page.menu
        }
      },
    ]
  }

  rawFormFields(item = undefined) {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        required: true,
        forceNextLine: true
      },
      {
        name: "description",
        displayName: this.fieldDisplayName("description"),
        type: "text",
        required: true,
        forceNextLine: true
      },
      {
        name: "content",
        displayName: this.fieldDisplayName("content"),
        type: "WYSIWYG",
        weight: 12,
        viewportTopOffset: parseInt(TopBarHeight)
      },
      {
        name: "downloadable",
        displayName: this.fieldDisplayName("downloadable"),
        type: "model",
        useCase: ListDownloadablesUseCase,
        primaryKey: "slug",
        foreignKey: "downloadable",
        allowClear: true,
        clearItem: '-',
        forceNextLine: true
      },
      {
        name: "extraContent",
        displayName: this.fieldDisplayName("extraContent"),
        type: "WYSIWYG",
        weight: 12,
        viewportTopOffset: parseInt(TopBarHeight)
      },
      {
        name: "headermenu",
        displayName: this.fieldDisplayName("headermenu"),
        type: "model",
        useCase: ListMenusUseCase,
        primaryKey: "slug",
        foreignKey: "menu",
        allowClear: true,
        clearItem: '-',
        forceNextLine: true
      },
      {
        name: "menuOrder",
        displayName: this.fieldDisplayName("menu_order"),
        type: "decimal",
        required: true,
        forceNextLine: true
      },
    ]
  }

  displayValue(item) {
    if(!item) {
      return "";
    }
    if(!item.slug) {
      return I18n.t(`${this.i18nScope()}.new`);
    }
    if(!item.name) {
      return `${I18n.t(`${this.i18nScope()}.name`, {count: 1} )} ${item.slug}`;
    }
    return item.name;
  }

  i18nScope() {
    return "model.frontend.page";
  }

  value(item) {
    if(!item) {
      return undefined;
    }
    return item.slug;
  }

}
const PageModel = new RawPageModel();

export { RawPageModel, PageModel }
